<p  *ngIf="info">
    <a #filelink href="{{'/files/' + (info.reference_id|| info.id)}}" (click)="openFile($event, '/files/' + (info.reference_id|| info.id))" target="_blank">
        {{item.value||item.text||item.translation_key| translation|translationFromString | transformText :item?.text_transform}}
        <span *ngIf="!item.text">
            <app-rendered [childview]="item.childview || childview" [paramprefix]="item.paramprefix" [info]="info" *ngFor="let it of item.content" [item]="it" [arr]="item.content" [data]="data"></app-rendered>
        </span>
    </a>
</p>
